<template>
  <flipper
    :status="maquina.status"
    class="container"
    style="height: 100%; width: 100%;"
    :active="field === 'oee'"
  >
    <Frame title="Máquina">
      <button
        v-if="fake"
        style="position:absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: transparent; border: none"
        @click="fakeStatusChange"
      ></button>
      <div class="colunas">
        <div>
          <rlabel
            class="machine-name"
            :text="machineLabel === 1 ? maquina.codigo : machineLabel === 2 ? maquina.descricao : maquina.codigo + '-' + maquina.descricao"
          ></rlabel>
          <div
            v-if="field !== 'oee'"
            style="position: relative; display: flex; height: calc(100% - 8rem); justify-content: space-between"
          >
            <div
              class="machine-info"
              style="display: flex; flex-direction: column; width: 48%; height:100%; justify-content: space-between"
            >
              <Frame title="Ordem">
                <span class="centered">
                  {{
                  maquina.ordem.substring(0, Math.min(maquina.ordem.length, 13))
                  }}
                </span>
              </Frame>
              <Frame title="Peça">
                <span class="centered">
                  {{
                  maquina.peca.substring(0, Math.min(maquina.peca.length, 13))
                  }}
                </span>
              </Frame>
              <div
                v-if="field === 'qualidade'"
                style="display: flex; border-radius: 1rem; height: 100%"
              >
                <Frame title="Boas" background="#4ac200" style="margin-right: 0.3rem;">
                  <p class="frame-qualidade">{{Math.floor(Math.random() * 3000)}}</p>
                </Frame>
                <Frame title="Def." background="#ffa200" style="margin-left: 0.3rem">
                  <p class="frame-qualidade">{{Math.floor(Math.random() * 100)}}</p>
                </Frame>
              </div>
            </div>

            <div class="main-chart small" style="width: 48%; height: 100%">
              <Frame title="Disponibilidade" v-if="field === 'disponibilidade'">
                <FrameContent>
                  <ChartContainer>
                    <Doughnut
                      color="rgba(54, 162, 235, 0.6)"
                      v-bind:complete="maquina.disponibilidade"
                    ></Doughnut>
                  </ChartContainer>
                </FrameContent>
              </Frame>
              <Frame title="Qualidade" v-if="field === 'qualidade'">
                <FrameContent>
                  <ChartContainer>
                    <Doughnut color="#90A4AE" v-bind:complete="maquina.qualidade"></Doughnut>
                  </ChartContainer>
                </FrameContent>
              </Frame>
            </div>
          </div>
          <div class="main-chart" v-if="field === 'oee'">
            <Frame title="OEE">
              <FrameContent>
                <ChartContainer>
                  <Doughnut color="#006064" v-bind:complete="maquina.oee"></Doughnut>
                </ChartContainer>
              </FrameContent>
            </Frame>
          </div>
        </div>
        <div>
          <div class="machine-info" v-if="field === 'oee'">
            <Frame title="Ordem">
              <span class="centered">
                {{
                maquina.ordem.substring(0, Math.min(maquina.ordem.length, 13))
                }}
              </span>
            </Frame>
            <Frame title="Peça">
              <span class="centered">
                {{
                maquina.peca.substring(0, Math.min(maquina.peca.length, 13))
                }}
              </span>
            </Frame>
          </div>
          <div :class="['machine-status', field !== 'oee' && 'fill']">
            <Frame title="Status" v-if="field === 'oee'">
              <div
                class="display-status"
                :class="{
                  produzindo: validaProd(maquina.status),
                  parada: validaParada(maquina.status),
                  ociosa: validaOciosa(maquina.status),
                  setup: validaSetup(maquina.status)
                }"
              >
                <p class="status-tag">
                  {{ maquina.status }}
                  <span
                    class="status-value"
                    v-if="maquina.status === 'Produção'"
                  >
                    {{
                    maquina.atraso > 0 ? "+" + maquina.atraso : maquina.atraso
                    }}
                  </span>
                  <!-- <font-awesome-icon
                  class="arrow"
                  icon="chevron-circle-up"
                  v-if="maquina.status === 'Produção' && maquina.atraso >= 0"
                  />-->
                  <font-awesome-icon
                    v-if="maquina.status === 'Produção'"
                    :class="['arrow', maquina.atraso < 0 && 'arrow-down']"
                    icon="chevron-circle-up"
                  />
                </p>
                <div class="bar-container">
                  <ProgressBar
                    :progress="maquina.progress"
                    :total="maquina.total"
                    :extra="'00:15:00'"
                    v-if="maquina.status === 'Produção'"
                  ></ProgressBar>
                  <div class="status-tag-time" v-if="maquina.status !== 'Produção'">
                    <p>{{ maquina.tempoEstado }}</p>
                  </div>
                </div>
              </div>
            </Frame>
            <Frame title="Principais Paradas" v-else-if="field === 'disponibilidade'">
              <chart-container style="padding-top: 1em">
                <bar-chart
                  color="#E05959"
                  label="Disponibilidade"
                  v-bind:valores="principaisParadas(maquina.indice)"
                  suffix="h"
                  :offset="-15"
                ></bar-chart>
              </chart-container>
            </Frame>
            <Frame title="Principais Defeitos" v-else-if="field === 'qualidade'">
              <chart-container style="padding-top: 1em">
                <bar-chart
                  color="#2Aa987"
                  label="Qualidade"
                  v-bind:valores="principaisDefeitos(maquina.indice)"
                  :offset="-15"
                ></bar-chart>
              </chart-container>
            </Frame>
          </div>
        </div>
      </div>
    </Frame>
  </flipper>
</template>

<script>
import Frame from "../Frame.vue";
import Doughnut from "../charts/Doughnut.js";
import ChartContainer from "../ChartContainer.vue";
import FrameContent from "../FrameContent.vue";
import ProgressBar from "../ProgressBar.vue";
import ResponsiveLabel from "../ResponsiveLabel";
import HorizontalBar from "../charts/HorizontalBar.js";
import Flipper from "../FlippingCard.vue";

import fakeData from "../../store/fakeData.js";

export default {
  name: "Machine4",
  components: {
    Frame,
    Doughnut,
    ChartContainer,
    FrameContent,
    ProgressBar,
    rlabel: ResponsiveLabel,
    "bar-chart": HorizontalBar,
    flipper: Flipper
  },
  props: {
    maquina: Object,
    field: String
  },
  methods: {
    validaProd(p) {
      let result = false;
      if (p === "Produção") result = true;

      return result;
    },
    validaParada(p) {
      let result = false;
      if (p === "Parada") result = true;

      return result;
    },
    validaOciosa(p) {
      let result = false;
      if (p === "Ocioso") result = true;

      return result;
    },
    validaSetup(p) {
      let result = false;
      if (p === "Setup") result = true;

      return result;
    },
    fakeStatusChange() {
      if (this.maquina.status === "Produção")
        fakeData[this.maquina.indice - 1].status = "Parada";
      else if (this.maquina.status === "Parada")
        fakeData[this.maquina.indice - 1].status = "Ocioso";
      else if (this.maquina.status === "Ocioso")
        fakeData[this.maquina.indice - 1].status = "Setup";
      else if (this.maquina.status === "Setup")
        fakeData[this.maquina.indice - 1].status = "Produção";
    }
  },
  computed: {
    machineLabel() {
      return this.$store.state.machineLabel;
    },
    fake() {
      return this.$store.state.fake;
    },
    principaisParadas() {
      return index => ({
        labels: [
          "Injustificada",
          "Manutenção Corretiva",
          "Troca de Ferramenta",
          "Liberada de Manutenção",
          "Manutentor na Máquina"
        ],
        valores:
          index === 1
            ? [358.33, 140.12, 140, 140, 3.4]
            : index === 2
            ? [220.2, 210.42, 134, 20, 10.5]
            : index === 3
            ? [300, 298.7, 103.5, 29.7, 4]
            : [321.49, 90, 82.3, 9, 2]
      });
    },
    principaisDefeitos() {
      return index => ({
        labels: [
          "Quebrada",
          "Corte Incorreto",
          "Porosidade",
          "Deformidade",
          "Outros Defeitos"
        ],
        valores:
          index === 1
            ? [135, 72, 66, 40, 10]
            : index === 2
            ? [240, 91, 77, 76, 14]
            : index === 3
            ? [174, 120, 118, 39, 20]
            : [300, 128, 120, 100, 90]
      });
    }
  }
};
</script>

<style scoped>
.first-line {
  display: flex;
  height: 8rem;
}

.container {
  max-width: 49.7%;
}

.colunas {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0.8rem 0.8rem;
}

.colunas > * {
  flex-basis: 50%;
  height: 100%;
}
.colunas > :first-child {
  margin-right: 0.8rem;
}

.machine-name {
  height: 8rem;
  font-size: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-chart {
  height: calc(100% - 8rem);
  border-radius: 1rem;
}

.small {
  height: calc(100% - 16rem);
}

span.centered {
  height: 100%;
  display: block;
  text-align: center;
}

.machine-info {
  height: 8rem;
  display: flex;
  border-radius: 1rem;
  font-size: 3rem;
}

.machine-info > :first-child {
  margin-right: 0.8rem;
}

.machine-status {
  height: calc(100% - 8rem);
  border-radius: 1rem;
}

.display-status {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 4rem;
}

.bar-container {
  width: 90%;
  margin: 0 auto;
  flex: 1;
}

.status-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.status-tag-time {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding-top: 2.5rem;
}

.status-value {
  font-size: 0.6em;
  padding: 0 1rem;
}

.produzindo {
  background-image: linear-gradient(to bottom, #388e3c, transparent 50%);
  background-image: linear-gradient(
    to bottom,
    var(--color-success),
    transparent 50%
  );
}

.parada {
  background-image: linear-gradient(to bottom, #b71c1c, transparent 50%);
  background-image: linear-gradient(
    to bottom,
    var(--color-stop),
    transparent 50%
  );
}

.ociosa {
  background-image: linear-gradient(to bottom, #1e88e5, transparent 50%);
  background-image: linear-gradient(
    to bottom,
    var(--color-danger),
    transparent 50%
  );
}

.setup {
  background-image: linear-gradient(to bottom, #20c997, transparent 50%);
  background-image: linear-gradient(
    to bottom,
    var(--color-setup),
    transparent 50%
  );
}

.arrow {
  color: #388e3c;
  color: var(--color-success);
  font-size: 0.6em;
}

.arrow-down {
  transform: rotate(180deg);
  color: #b71c1c;
  color: var(--color-stop);
}

.fill {
  height: 100% !important;
  max-height: 100%;
}

.frame-qualidade {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  font-size: 1.5vw;
}
</style>
